import { merge } from 'lodash';

export function mergeLineOpt(op) {
  return merge(
    {
      title: {
        text: 'line',
        textStyle: {
          color: '#00A0E9',
          fontSize: 24
        },
        show: false
      },
      tooltip: {
        trigger: 'axis',
        backgroundColor: '#fff',
        textStyle: {
          color: '#000',
          fontSize: 14
        }
      },
      legend: {
        right: 100,
        textStyle: {
          color: '#fff',
          fontSize: 16
        },
        tooltip: {
          show: true
        }
      },
      grid: {
        left: '3%',
        right: '4%',
        bottom: '3%',
        containLabel: true
      },
      dataZoom: {
        type: 'inside'
      },
      toolbox: {
        feature: {
          saveAsImage: {}
        }
      },
      xAxis: {
        type: 'time',
        splitLine: {
          show: false
        }
      },
      yAxis: {
        type: 'value',
        axisLine: {
          show: true
        }
      },
      series: []
    },
    op
  );
}

export function mergeBarOpt(op) {
  return merge(
    {
      title: {
        text: '报警事件汇总',
        right: 'center',
        top: '5',
        textStyle: {
          color: '#04c5d5',
          fontSize: '26'
        }
      },
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'none'
        }
      },
      grid: {
        left: '3%',
        right: '4%',
        bottom: '3%',
        containLabel: true
      },
      xAxis: {
        type: 'category',
        axisTick: {
          alignWithLabel: true
        }
      },
      yAxis: [
        {
          type: 'value',
          axisLine: {
            show: true,
            lineStyle: {
              color: '#04c5d5'
            }
          }
        }
      ],
      series: {
        name: '报警次数',
        type: 'bar',
        barWidth: '20%'
      }
    },
    op
  );
}

export function mergeBoxplot(op) {
  const res = merge(
    {
      color: ['#4992ff'],
      title: {
        text: '各主要监测项归一化值',
        right: '5%',
        textStyle: {
          color: '#04c5d5'
        }
      },
      tooltip: {
        trigger: 'item',
        axisPointer: {
          type: 'shadow'
        }
      },
      grid: {
        left: '6%',
        right: '10%',
        bottom: '15%'
      },
      xAxis: {
        type: 'category',
        boundaryGap: true,
        nameGap: 30,
        axisLine: {
          show: true,
          lineStyle: {
            color: '#04c5d5'
          }
        }
      },
      yAxis: {
        type: 'value'
      },
      dataZoom: [
        {
          type: 'inside',
          yAxisIndex: [0],
          start: 0
        }
      ],
      series: [
        {
          name: 'boxplot',
          type: 'boxplot',
          tooltip: {
            formatter: function (param) {
              return [
                'Experiment ' + param.name + ': ',
                'upper: ' + param.data[5],
                'Q3: ' + param.data[4],
                'median: ' + param.data[3],
                'Q1: ' + param.data[2],
                'lower: ' + param.data[1]
              ].join('<br/>');
            }
          }
        },
        {
          name: '异常值',
          type: 'scatter'
        }
      ]
    },
    op
  );
  return res;
}

export function makeSeries({ name, ordata, dimensions }) {
  return {
    name,
    type: 'line',
    showSymbol: false,
    data: ordata.map((e, i) => [dimensions[i], e])
  };
}

function axisCommon() {
  return {
    axisLine: {
      lineStyle: {
        color: '#04c5d5'
      }
    },
    splitLine: {
      lineStyle: {
        color: '#04c5d5'
      }
    },
    minorSplitLine: {
      lineStyle: {
        color: '#04c5d5'
      }
    }
  };
}

export const theme = {
  backgroundColor: '#0c1620',
  color: [
    '#5b88ff',
    '#7cffb2',
    '#fddd60',
    '#ff6e76',
    '#58d9f9',
    '#05c091',
    '#ff8a45',
    '#8d48e3',
    '#dd79ff'
  ],
  textStyle: {
    color: '#04c5d5'
  },
  categoryAxis: axisCommon(),
  timeAxis: axisCommon(),
  axisPointer: {
    lineStyle: {
      color: 'rgba(5, 196, 211, .5)'
    }
  },
  valueAxis: {
    axisLine: {
      lineStyle: {
        color: '#04c5d5'
      }
    },
    splitLine: {
      lineStyle: {
        color: '#162543'
      }
    },
    minorSplitLine: {
      lineStyle: {
        color: '#162543'
      }
    }
  }
};
